import { useEffect } from 'react';
import { DYNAMIC_CLASSES } from '../enums';

const useDisableIntercom = (isDisablingIntercom: boolean = true): void => {
  const intercom = document.querySelectorAll(
    `${DYNAMIC_CLASSES.INTERCOM_INITIAL},
    ${DYNAMIC_CLASSES.INTERCOM_OPENED}`
  );
  const intercomApp = intercom?.item(0) as HTMLElement | null;
  if (isDisablingIntercom && intercomApp) {
    intercomApp.style.display = 'none';
  } else if (!isDisablingIntercom && intercomApp) {
    intercomApp.style.display = 'initial';
  }
  useEffect(() => {
    return () => {
      if (isDisablingIntercom && intercomApp) {
        intercomApp.style.display = 'initial';
      }
    };
  }, []);
};

export default useDisableIntercom;
